import { type PropsWithChildren } from "react";
import { BrandLogo } from "@/components/redesign/BrandLogo";
import { cn } from "@/lib/utils";
import { DOWNLOAD_APP_CTA_CLEARANCE_CLASS } from "@/components/mobile/DownloadAppCta";

interface AuthLayoutProps extends PropsWithChildren {
  isMobileWeb: boolean;
}

export function AuthLayout({ children, isMobileWeb }: AuthLayoutProps) {
  return (
    <main
      className={cn(
        "flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-[#f9fafb] px-6 py-10",
        isMobileWeb && DOWNLOAD_APP_CTA_CLEARANCE_CLASS,
      )}
    >
      <BrandLogo />
      {children}
    </main>
  );
}

export const clerkAuthAppearance = {
  elements: {
    rootBox: "w-full max-w-[400px]",
    cardBox: "w-full shadow-[0_16px_36px_rgba(10,12,17,0.16)] rounded-xl",
    card: "w-full border border-[#dddfe4] rounded-xl shadow-none",
    headerTitle: "text-[#0a0c11] font-semibold",
    headerSubtitle: "text-[#5b616d]",
    formButtonPrimary:
      "h-12 rounded-lg bg-[#303238] hover:bg-[#22242a] normal-case text-sm font-semibold",
    formFieldInput: "h-12 rounded-lg border-[#dddfe4]",
    socialButtonsBlockButton: "h-11 rounded-lg border-[#dddfe4]",
    footer: "rounded-b-xl bg-[#f9fafb]",
  },
} as const;
